import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithIsHome } from '~/core/styleTypes';

export const CompareContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiLarge}
    display: flex;
    flex-direction: column;
`;

export const HeaderContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    flex-direction: column;
`;

export const HeaderAndSeparator = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    display: flex;
    flex-direction: column;
`;

export const HeaderName = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['20b']}

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['24b']}
    }
`;

export const SubHeader = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['16b']}
    color: ${({ theme }) => theme.Text.secondary};
    padding-bottom: 4px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        padding-bottom: 0;
    }
`;

export const TeamContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 1;

    img {
        height: 40px;
        width: 60px;

        ${BaseStyle.Mixins.screenSizes.medium} {
            height: 48px;
            width: 72px;
        }
    }
`;

export const TeamItem = styled.div<WithIsHome>`
    flex: ${({ $isHome }) => ($isHome ? 'initial' : 1)};
`;
